<template>
  <div class="step-container scrollPosition haus-step-5">
    <div class="step-header">
      <h2 class="step-title">Sanierung</h2>
      <p class="step-text">Welche Sanierungen wurden bereits durchgeführt?</p>
    </div>
    <div class="step-body">
      <div class="box-container">
        <ActionBox
          class="box-item small-icon-w-50"
          text="Erhaltungs-<br/>maßnahmen"
          @click="setSanierung(20)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8388.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8388_white.svg')"
        />

        <ActionBox
          class="box-item small-icon-w-50"
          text="Teilsanierungen innen und/oder außen"
          @click="setSanierung(40)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8386.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8386_white.svg')"
        />

        <ActionBox
          class="box-item small-icon-w-50"
          text="General-<br/>sanierung"
          @click="setSanierung(50)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8389.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8389_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Keine oder nicht bekannt"
          @click="setSanierung(10)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8390.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8390_white.svg')"
        />
      </div>
    </div>
    <div class="step-footer">
      <div class="row">
        <div class="col-md-4 col-sm-4 text-start">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionBox from "@/components/shared/ActionBox.vue";
import { saveToStorage } from "@/utils.js";
export default {
  name: "haus-step-5",
  components: {
    ActionBox,
  },
  data() {
    return {
      fields: {
        indexArtGebaeudesanierung: { value: null },
      },
    };
  },
  methods: {
    setSanierung(index) {
      this.fields.indexArtGebaeudesanierung.value = index;
      saveToStorage(this.fields);
      this.$router.push("/haus-step-6");
    },
    goBack() {
      this.$router.push("/haus-step-4");
    },
  },
  mounted() {
    this.$emit("setStep", "haus", 6);
  },
};
</script>
<style scoped>
.box-container {
  gap: 30px;
}
.box-item {
  flex-basis: 180px;
  height: 190px;
}
@media only screen and (max-width: 768px) {
  .box-container {
    gap: 20px;
  }
  .box-item {
    height: 100%;
  }
}
</style>
